import React from 'react';
import { Navbar } from '../components/Navbar';
import { DonorRecognitionPage } from '../components/DonorRecognitionPage';
import { Footer } from '../components/Footer';
export const DonorRecognition = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2345">
      <Navbar data-id="element-2346" />
      <DonorRecognitionPage data-id="element-2347" />
      <Footer data-id="element-2348" />
    </div>;
};